import { LoadingProductCardList } from '@components/ProductCard'
import { Headline } from '@components/designSystem/Headline'
import { Badge } from '@components/designSystem/badges/badges'
import useTypedTranslation from '@hooks/useTypedTranslation'
import ProductCard from '@routes/ProductFinder/ProductCard'

import type { SearchType } from '@components/productFinder/state'
import type { ProductWrapper } from '@state/product'

interface ResultListProps {
  items: ProductWrapper[]
  selectGtin: (gtin: string) => void
  selectedGtin: string | undefined
  searchType: SearchType
  searchTerm: string
  isLoading: boolean
}

function ResultList({ items, selectGtin, selectedGtin, searchType, searchTerm, isLoading }: ResultListProps) {
  if (isLoading) {
    return <LoadingProductCardList count={8} />
  }

  if (items.length === 0) {
    return <NoResult type={searchType} term={searchTerm} />
  }

  return (
    <ul className="flex flex-col gap-2" data-testid='search-results' role='listbox'>
      {items.map((item) => {
        //show a gtin badge if the search was done by gtin
        const badges = searchType === 'gtin' ? [<Badge size='sm' key="gtin-badge">{item.gtin}</Badge>] : []

        return (
          <li key={item.gtin}>
            <ProductCard
              key={item.gtin}
              product={item}
              onClick={() => selectGtin(item.gtin)}
              isSelected={selectedGtin === item.gtin}
              badges={badges}
            />
          </li>
        )
      })}
    </ul>
  )
}

interface NoResultProps {
  type: SearchType
  term: string
}

function NoResult({ type, term }: NoResultProps) {
  const { t } = useTypedTranslation()

  const subline = type === 'term' ?
    'productFinder.noResults.subtitleSearchTerm' :
    'productFinder.noResults.subtitleGtin'

  return (
    <div className='mt-14 text-center' data-testid='no-results'>
      <Headline title={t('productFinder.noResults.title')}/>
      {t(subline, { term })}
    </div>
  )
}

export default ResultList